var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_2240_9859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.8912 31.6903L69.249 42.0898V57.9101L95.8912 68.3095C97.8631 69.089 100 67.6356 100 65.5153C100 65.0894 100 34.9103 100 34.4843C100 32.3642 97.8631 30.9109 95.8912 31.6903Z",
    fill: "#596C76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8912 62.773L69.249 52.3735V57.9099L95.8912 68.3093C97.8631 69.0888 100 67.6355 100 65.5151C100 65.4019 100 63.1827 100 59.9788C100 62.0991 97.8631 63.5523 95.8912 62.773Z",
    fill: "#465A61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.777 82.0472C72.0955 82.0472 74.7857 79.3569 74.7857 76.0384V23.9614C74.7857 20.6429 72.0955 17.9526 68.777 17.9526H6.00879C2.69023 17.9526 0 20.6429 0 23.9614C0 25.4306 0 77.303 0 76.0384C0 79.3569 2.69023 82.0472 6.00879 82.0472C7.58105 82.0472 70.3943 82.0472 68.777 82.0472Z",
    fill: "#8D9CA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3729 70.4469C48.6655 70.4469 57.8199 61.2924 57.8199 49.9998C57.8199 38.7072 48.6655 29.5527 37.3729 29.5527C26.0802 29.5527 16.9258 38.7072 16.9258 49.9998C16.9258 61.2924 26.0802 70.4469 37.3729 70.4469Z",
    fill: "#D8ECFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4863 40.9333V59.0665C28.4863 61.0503 30.6178 62.304 32.3516 61.3403L48.6623 52.2737C50.4457 51.2825 50.4457 48.7175 48.6623 47.7262L32.3516 38.6596C30.6178 37.6956 28.4863 38.9495 28.4863 40.9333Z",
    fill: "#FE646F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7768 17.9526H61.9326C65.2512 17.9526 67.9414 20.6429 67.9414 23.9614V76.0384C67.9414 79.3569 65.2512 82.0472 61.9326 82.0472H61.9617H68.7768C72.0953 82.0472 74.7855 79.3569 74.7855 76.0384V23.9614C74.7855 20.6429 72.0953 17.9526 68.7768 17.9526Z",
    fill: "#7A8C98"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2240_9859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamera);
export default __webpack_public_path__ + "static/media/video-camera.99b7fe85ca2e366c285fd2202d064ebf.svg";
export { ForwardRef as ReactComponent };